<template>
  <div class="content">
    <div class="header">
      <span>视频详情</span>
      <span class="choose-space">更换</span>
    </div>
    <div class="line cross-line"></div>
    <video-list-comp/>
  </div>
</template>

<script>
import VideoListComp from "@/views/basic_operations/monitoring/video_surveillance/comp/VideoListComp";

export default {
  name: "VideoSurveillance",
  components: {VideoListComp}
}
</script>

<style scoped>
.content {
  padding: 20px;
}

.header {
  width: 100%;
  margin: 18px 5px 0 5px;
  height: 19px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 19px;
  color: #01EFFD;
  opacity: 0.8;
}

.choose-space {
  float: right;
  margin-right: 10px;
  text-decoration: underline;
}

.choose-space:hover {
  opacity: 1;
  cursor: pointer;
}

.cross-line {
  margin: 14px 0 29px 0;
  width: 100%;
  height: 0;
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.2;
}
</style>
